/*
 * @Author: luting
 * @Date: 2022-05-05 18:56:04
 * @lastEditors: luting
 * @LastEditTime: 2022-11-17 18:21:06
 */
import React, { useState } from 'react';
import { Radio } from 'sup-ui';
import { radioOptions } from './data';

import Notice from './Notice';
import Person from './Person';

import styles from './index.less';

const WarnNotification = () => {
  const [activeValue, setActiveValue] = useState('notice');

  const onRadioChange = (e: any) => {
    setActiveValue(e.target.value);
  };

  return (
    <div className={styles.warnContainer}>
      <Radio.Group className={styles.warnBtnGroup} onChange={onRadioChange} value={activeValue}>
        {radioOptions.map((item) => (
          <Radio.Button value={item.value} key={item.key}>
            {item.label.defaultMessage}
          </Radio.Button>
        ))}
      </Radio.Group>

      {activeValue === 'notice' ? <Notice /> : <Person />}
    </div>
  );
};

export default WarnNotification;
